<template>
  <div class="container">
    <div class="message">
      <div class="image" v-if="message.image_url">
        <img :src="message.image_url" />
      </div>
      <div class="content">
        <div class="title" v-if="message.title">{{ message.title }}</div>
        <div class="subtitle">{{ message.subtitle }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FacebookMessagePreview',
  props: {
    message: Object
  }
}
</script>

<style scoped>
.container {
  width: 300px;
  display: inline-block;
}

.message {
  -moz-border-radius: 10px;
  -webkit-border-radius: 10px;
  border-radius: 10px;
  cursor: default;
  position: relative;
  text-align: left;
  border: 1px solid #cccccc;
  box-shadow: 0 0 10px #cccccc;
  overflow: hidden;
}

.content {
  padding: 10px;
}
.title {
  color: #000000;
  margin-bottom: 3px;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 17px;
  white-space: nowrap;
}
.subtitle {
  color: #141414;
  max-height: 60px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.image {
  text-align: center;
}
.image img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/common/components/facebook/FacebookMessagePreview.vue